import { AfterContentInit, Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { CardPaymentRedirectHelper } from '@complete-order/classes/card.payment.redirect.helper.class';
import { CompleteOrderService } from '@complete-order/services/complete-order.service';
import {
  CurrentPlan,
  Contact,
  Address,
  CardPaymentRedirectResponse,
  CardPaymentRedirectRequest,
  slideInOut,
} from '@dgx-pr-spa/shared/util';
import { AddressFormBuilder } from '@domgen/dgx-fe-forms/address';

@Component({
  selector: 'app-worldpay-billing-address',
  templateUrl: './worldpay-billing-address.component.html',
  styleUrls: ['./worldpay-billing-address.component.scss'],
  animations: [slideInOut],
})
export class WorldpayBillingAddressComponent
  implements OnInit, AfterContentInit
{
  formGroup: UntypedFormGroup;
  addressChanged = false;
  defaultAddress;

  constructor(
    public completeOrderService: CompleteOrderService,
    private readonly addressFormBuilder: AddressFormBuilder
  ) {}
  @Input() currentPlan: CurrentPlan;
  @Input() replacementCost: number;
  @Input() contactDetails: Contact;
  @Input() deliveryAddress: Address;

  @Input() cardPaymentRedirect: {
    request: CardPaymentRedirectRequest;
    response: CardPaymentRedirectResponse;
    addressChanged: boolean;
  };

  showAddress = false;

  get toggledValue() {
    return this.formGroup.get('toggled').value;
  }

  ngOnInit(): void {
    this.addressChanged = this.cardPaymentRedirect?.addressChanged;

    this.formGroup = new UntypedFormGroup({
      address: this.addressFormBuilder.buildAddressForm(),
      additionalAddress: this.addressFormBuilder.buildAdditionalAddressForm(),
      toggled: new UntypedFormControl(this?.addressChanged ? false : true),
    });
  }

  ngAfterContentInit() {
    this.formGroup?.get('toggled')?.valueChanges?.subscribe((toggled) => {
      if (this.addressChanged && toggled) {
        this.addressChanged = false;

        const request = new CardPaymentRedirectHelper(
          this.currentPlan,
          this.replacementCost,
          this.contactDetails,
          this.deliveryAddress
        ).requestBody;

        this.completeOrderService.loadCardPaymentRedirect({
          request: request,
          addressChanged: false,
        });
      }
    });
  }

  changeAddress(formGroup: UntypedFormGroup) {
    if (formGroup?.get('address').valid) {
      const address = formGroup?.get('address').value;

      this.addressChanged = true;

      const request = new CardPaymentRedirectHelper(
        this.currentPlan,
        this.replacementCost,
        this.contactDetails,
        this.deliveryAddress
      ).requestBody;

      this.completeOrderService.loadCardPaymentRedirect({
        request: {
          ...request,
          billingAddress: {
            addressLine1: address.addressLine1,
            addressLine2: address.addressLine2 || '',
            addressLine3: address.addressLine3 || '',
            addressLine4: address.addressLine4 || '',
            postalCode: address.postalCode,
            countryCode: address.countryCode,
          },
        },
        addressChanged: true,
      });
    }
  }
}
